/**
 * @generated SignedSource<<83d1abeb8d8d7b84a9c186e9bef3414f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateNotificationRuleHeader_query$data = {
  readonly jiraInstances: {
    readonly pageInfo: {
      readonly total: number | null | undefined;
    };
  } | null | undefined;
  readonly " $fragmentType": "CreateNotificationRuleHeader_query";
};
export type CreateNotificationRuleHeader_query$key = {
  readonly " $data"?: CreateNotificationRuleHeader_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateNotificationRuleHeader_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateNotificationRuleHeader_query",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "JiraInstanceConnection",
      "kind": "LinkedField",
      "name": "jiraInstances",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "total",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "165e77ecd1ed3f84611f9a9dd41db5cf";

export default node;
